var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "M12.292 15.833A2.29 2.29 0 0 1 10 18.125a2.29 2.29 0 0 1-2.292-2.292A2.29 2.29 0 0 1 10 13.542a2.29 2.29 0 0 1 2.292 2.291m-3.334 0a1.042 1.042 0 1 0 2.085 0 1.042 1.042 0 0 0-2.085 0M12.292 4.167A2.29 2.29 0 0 1 10 6.458a2.29 2.29 0 0 1-2.292-2.291A2.29 2.29 0 0 1 10 1.875a2.29 2.29 0 0 1 2.292 2.292m-3.334 0a1.042 1.042 0 1 0 2.084-.001 1.042 1.042 0 0 0-2.084 0M12.292 10A2.29 2.29 0 0 1 10 12.292 2.29 2.29 0 0 1 7.708 10 2.29 2.29 0 0 1 10 7.708 2.29 2.29 0 0 1 12.292 10m-3.334 0a1.042 1.042 0 1 0 2.085 0 1.042 1.042 0 0 0-2.085 0"
  })));
};
export default SvgMore;